import React from 'react'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { TableFeature, useTiersInfo } from '@mc/plans-ui'
import { BOGO_I18N_NAMESPACE, i18nInstance } from '../../../i18n'
import { BogoFeatureLabel } from '../BogoFeatureLabel'
import { BogoPricingPlanCell } from '../BogoPricingPlanCell'
import classes from './BogoPricingRows.module.scss'

const BogoPricingRowsComp = () => {
  const { individual, duo, family } = useTiersInfo()
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)

  return (
    <>
      <TableFeature.Feature className={classes.pricingRow}>
        <BogoFeatureLabel
          title={t('plans.rows.membership.title')}
          subtitle={t('plans.rows.membership.subtitle')}
        />
        <TableFeature.Individual>
          <BogoPricingPlanCell tier={individual} />
        </TableFeature.Individual>
        <TableFeature.Duo>
          <BogoPricingPlanCell tier={duo} />
        </TableFeature.Duo>
        <TableFeature.Family>
          <BogoPricingPlanCell tier={family} />
        </TableFeature.Family>
      </TableFeature.Feature>

      <TableFeature.Feature className={classes.pricingRow}>
        <BogoFeatureLabel
          title={t('plans.rows.gift.title')}
          subtitle={t('plans.rows.gift.subtitle')}
        />
        <TableFeature.Individual>
          <BogoPricingPlanCell tier={individual} strikedValue />
        </TableFeature.Individual>
        <TableFeature.Duo>
          <BogoPricingPlanCell tier={duo} strikedValue />
        </TableFeature.Duo>
        <TableFeature.Family>
          <BogoPricingPlanCell tier={family} strikedValue />
        </TableFeature.Family>
      </TableFeature.Feature>
    </>
  )
}

export const BogoPricingRows =
  withI18nContext(i18nInstance)(BogoPricingRowsComp)
